import FilterInput from './FilterInput'

export default FilterInput
